module.exports = __webpack_public_path__ + "static/media/3DPPA44.24f17516.jpg";